<template>

  <div class="data-grid-table">
    <div class="btn-group toolbar" role="group" v-if="parsedFieldsData.length">
      <button type="button" class="btn btn-success" @click="_new" v-bind:class="{disabled: isReadOnly}">
        <i class="icon wb-plus" aria-hidden="true"></i>
      </button>
    </div>
    <div class="btn-group toolbar" role="group" style="margin-left: 5px;">
      <button type="button" class="btn btn-outline btn-default z-index">
        <i class="icon fa-database" aria-hidden="true"></i>
        <span class="badge badge-danger corner up">{{ count }}</span>
      </button>
    </div>

    <table
      v-if="definitionResponse && parsedFieldsData.length"
      data-unique-id="ID"
      id="tableid"
      ref="grid"
      data-mobile-responsive="true"
      data-row-style="rowStyle"
      data-show-columns="true"
    >
    </table>
    <div
      ref="preloader"
      class="preloader-wrapper"
    >
      <div class="loader loader-grill"></div>
    </div>
  </div>

</template>

<script>
import ResourceGetter       from '../../../model/resource/getter/resource-getter'
import DataGridPreprocessor from '../../../model/preprocessor/grid-data-preprocessor'
import { http }             from '@/http'
import Swal                 from 'sweetalert2/dist/sweetalert2.js'
import PDELinkGenerator     from '../../../model/wrapper/pde-link-params'
import SessionStorage       from '../../../model/storage/session-storage'
import IconRenderer         from '../../../model/helper/icon-render'
import ImageRenderer        from '../../../model/helper/image-render'

// @deprecated
export default {
  props: {
    pageType:           {
      type: String
    },
    row:                {
      type:    Object,
      default: function () {
        return null
      }
    },
    definitionResponse: {
      type:    Object,
      default: function () {
        return null
      }
    },
    scrollFiredProp:    {
      type:    Boolean,
      default: false
    },
    whereCondition:     {
      type:    String,
      default: null
    },
    orderBy:            {
      type:    String,
      default: null
    },
    menuField:          {
      type:    Object,
      default: function () {
        return null
      }
    },
    def:                {
      type:    Object,
      default: function () {
        return null
      }
    },
    redir:              {
      type:    String,
      default: 'grid'
    },
    parent:             {
      type:    Object,
      default: function () {
        return null
      }
    }
  },
  data () {
    return {
      h1:            '',
      idStructure:   this.$route.params.idStructure,
      sourceType:    null,
      businessRules: null,
      resource:      null,

      data:          [],
      storeGridData: null,
      topPosition:   0,
      searchedText:  null,
      count:         0,

      images: [],

      limit:        null,
      offset:       null,
      isLastOffset: false,
      where:        null,
      isReadOnly:   false,
      layout:       undefined,

      gridColumns: [
        { field: 'field1', title: 'label1' },
        { field: 'field2', title: 'label2' }
      ],

      parsedFieldsData: [],

      scrollFiredPropLocal: undefined,

      computed: {
        pageType: undefined
      }
    }
  },

  computed: {
    innerPageType: {
      get: function () {
        if (this.computed.pageType) {
          return this.computed.pageType
        }

        return this.pageType
      },
      set: function (value) {
        this.computed.pageType = value
      }
    }
  },

  watch: {
    'pageType': function (pageTypeString) {
      this._baseWatcherListener(pageTypeString)
    }
  },

  created () {
    let search = SessionStorage.getArrayItem('search', window.location.href)

    this.scrollFiredPropLocal = this.scrollFiredProp
    this.searchedText         = search ? search.text : null

    this._initBase(this.innerPageType)

    window.addEventListener('scroll', this._handleScroll)
  },

  destroyed () {
    window.removeEventListener('scroll', this._handleScroll)
  },

  methods: {

    /**
     * @param pageType
     * @private
     */
    _initBase (pageType) {
      let parsedData = this._parsePageTypeString(pageType)

      this.innerPageType = parsedData[0]
      this.idStructure   = parsedData[1]
      // this.storeGridData = this.$store.getters.getGridData(pageType)

      // cekame na odpoved definice
      let initDefinitions = this._initDefinitions()
      Promise
        .all([initDefinitions])
        .then(() => {

          // cekame na odpoved data
          let initData = this._initData(null, this._prepareArgs())
          Promise
            .all([initData])
            .then(() => {

              // jakmile jsou definice a data pripravena -> vykreslujeme grid
              this._initGrid()

            })
            .catch((arg) => {
              for (let i = 0; i < arg.length; i++) {
                this.handleApiError(arg[i])
              }
            })

        })
        .catch((arg) => {
          for (let i = 0; i < arg.length; i++) {
            this.handleApiError(arg[i])
          }
        })
    },

    /**
     * @private
     */
    _initDefinitions () {
      this.gridColumns = []
      this.images      = []

      let response      = this.definitionResponse,
          businessRules = {
            newrec:       this.definitionResponse.data[0].NewRec,
            valrec:       this.definitionResponse.data[0].ValRec,
            calrec:       this.definitionResponse.data[0].CalRec,
            delrec:       this.definitionResponse.data[0].DelRec,
            aftersaverec: this.definitionResponse.data[0].AfterSaveRec
          }

      if (this.def.listIcons.length) {
        let icons = {
          field:     'icons',
          title:     '',
          fieldType: 'icon',
          formatter: (value, row) => {
            return IconRenderer
              .setTranslator(this.$translate)
              .render(this.def.listIcons, row)
          }

        }
        this.gridColumns.push(icons)
      }

      if (this.def.listImages.length) {
        let icons = {
          field:     'images',
          title:     '',
          fieldType: 'image',
          formatter: (value, row) => {
            return ImageRenderer.render(this.def.listImages, row)
          }

        }
        this.gridColumns.push(icons)
      }

      for (let i = 0; i < this.def.filteredGrid.length; i++) {
        let item = this.def.filteredGrid[i]

        let column = {
          field:     item.Field,
          title:     this.$translate.text(item.Label),
          fieldType: item.FieldType,
          dataType:  item.DataType
        }

        if (item.FieldType === 'Autocomplete' || item.FieldType === 'DropDown') {
          column.field = 'ST' + item.Field
        }

        if (item.hasOwnProperty('Document.Field.FileGUID')) {

          column.field = '_temp_' + column.field
          this.images.push({
            columnName: item.Field,
            fileGUID:   item['Document.Field.FileGUID']
          })
        }

        // zpracovani icon na sloupcich
        if (item.hasOwnProperty('Fields') && item.Fields.length) {
          let icons = []
          item.Fields.forEach((element) => {
            if (element.FieldType !== 'Icon') {
              return
            }

            icons.push(element)
          })

          column.formatter = (value, row) => {
            return IconRenderer
              .setTranslator(this.$translate)
              .render(icons, row) + ' ' + value
          }
        }

        this.gridColumns.push(column)
      }

      this.parsedFieldsData = this.def.editor
      this.resource         = ResourceGetter.get(this.def.viewName)
      this.businessRules    = businessRules
      this.sourceType       = this.def.viewName
      this.limit            = this.resource.defaults().limit
      this.offset           = this.resource.defaults().offset
      this.h1               = response.data[0].DictionaryKeyCode
      this.where            = response.data[0].WhereCondition
      this.layout           = response.data[0].Layout

      if (response.data[0].hasOwnProperty('IsReadOnly') && response.data[0].IsReadOnly === 'true') {
        this.isReadOnly = true
      }
      else {
        this.isReadOnly = false
      }
    }
    ,

    /**
     *
     * @param callback
     * @param args
     * @param enforce - vynuti volani api
     */
    _initData (callback, args, enforce = false) {
      if (
        this.layout !== 'API_Refresh'
        && this.storeGridData
        && this.storeGridData.lastPage === this.innerPageType
        && !this.searchedText
        && !enforce
      ) {
        this.data         = this.storeGridData.lastData
        this.offset       = this.storeGridData.lastOffset
        this.searchedText = this.storeGridData.searchedText
        this.count        = this.storeGridData.lastCount
        this.isLastOffset = this.storeGridData.isLastOffset

        return
      }

      if (this.layout === 'API_Refresh' && this.storeGridData && !this.searchedText) {
        this.searchedText = this.storeGridData.searchedText
        this.count        = this.storeGridData.lastCount
        args.searchText   = this.searchedText
      }

      if (this.isLastOffset && !enforce) {
        return true
      }

      $(this.$refs.preloader).show()

      if (!this.resource && this.storeGridData.lastResource) {
        this.resource = this.storeGridData.lastResource
      }

      args.idtEntity = this.idStructure
      if (this.searchedText) {
        args.searchText = this.searchedText
      }

      return this
        .resource
        .setDef(this.def)
        .find(args)
        .then(response => {

          if (response.data.length < this.limit) {
            this.isLastOffset = true
          }

          this.data  = response.data
          this.count = response.data.length ? response.data[0].ROWS_COUNT : (this.searchedText ? 0 : this.count)
          this._preprocessData()

          if (callback) {
            callback()
          }

          $(this.$refs.preloader).hide()

        })
        .catch(error => {
          this.handleApiError(error)
        })
    }
    ,

    /**
     *
     * @param method
     * @param callbck
     * @param enforce
     */
    _gridLoadData (method = 'load', callbck, enforce = false) {
      let originalData = this.data,
          args         = this._prepareArgs()

      args['searchText'] = this.searchedText

      let callback = () => {
        this.grid.bootstrapTable(method, this.data)
        if (method !== 'load') {
          for (let i = 0; i < this.data.length; i++) {
            originalData.push(this.data[i])
          }
          this.data = originalData
        }

        if (callbck) {
          callbck()
        }
      }

      this._initData(callback, args, enforce)
    }
    ,

    /**
     *
     * Transformuje hodnoty na mozadovany tvar
     */
    _preprocessData () {
      DataGridPreprocessor.preprocessData(this.data, this.gridColumns)

      // kontrola jestli se vracime na grid z editoru -> doslo k insertu nebo updatu zaznamu
      // pokud doslo k insertu odebereme inserotvany radek ze seznamu dat
      // poznm. nelzde zde provest premisteni zaznamu -> v datech nemusi byt insertovany zaznam obsazen! -> vice zaznamu nez LIMIT !
      if (!this.row || !this.$store.getters.getGridEditTag) {
        return
      }

      if (this.row.type === 'insert') {
        let tempItem = null

        for (let i = 0; i < this.data.length; i++) {
          let item = this.data[i]

          if (item.ID === this.row.data.ID) {
            tempItem = item

            this.data.splice(i, 1)
          }

        }
      }
    }
    ,

    /**
     *
     * @private
     */
    _initGrid () {
      if (this.grid) {
        this.grid.bootstrapTable('refreshOptions', { columns: this.gridColumns })
        this.grid.bootstrapTable('refresh')
        this._setGridLastState()
        this._updateDataItem()

        return
      }

      this.grid = $(this.$refs.grid)

      let options = {
        data:                this.data,
        search:              true,
        stickyHeader:        true,
        stickyHeaderOffsetY: '102px',
        searchText:          this.searchedText ? this.searchedText : '',
        showRefresh:         true,
        showToggle:          false,
        showColumns:         false,
        columns:             this.gridColumns,
        trimOnSearch:        false,
        toolbar:             '.toolbar',
        iconSize:            'outline',
        icons:               {
          refresh: 'wb-refresh',
          toggle:  'wb-order'
          // columns: "wb-list-bulleted"
        },
        formatSearch:        () => {
          return ''
        },
        formatNoMatches:     () => {
          return this.$translate.text('tbl_data_no_found')
        },
        onClickRow:          (rowData) => {
          this._saveGridState(rowData.ID)
          this.$store.commit('setGridEditTag', true)
          this.$store.commit('setRowData', { type: 'lastRow', data: rowData })

          PDELinkGenerator.defaults = rowData
          PDELinkGenerator.redir    = this.redir

          if (this.parent) {
            let parent                 = {
              id:           this.$route.params.id,
              page:         this.$route.params.page,
              idEStructure: this.$route.params.idStructure,
              label:        this.parent.data.SEARCHTEXT
            }
            PDELinkGenerator.parent    = JSON.stringify(parent)
            PDELinkGenerator.parentDef = this.parent.def
          }

          this.$router.push(PDELinkGenerator.getParams(this.def))
        },
        onRefresh:           () => {
          this.limit         = this.resource.defaults().limit
          this.offset        = this.resource.defaults().offset
          this.searchedText  = null
          this.storeGridData = null
          this.isLastOffset  = false

          SessionStorage.clearArray('search', window.location.href)

          this.grid.bootstrapTable('resetSearch')

          this._gridLoadData('load', () => {
            this._changeGridData()
          })

          window.scrollTo(0, 0)
        },
        customSearch:        (text) => {
          if (text === this.searchedText || text === undefined) {
            return
          }

          this.limit        = this.resource.defaults().limit
          this.offset       = this.resource.defaults().offset
          this.isLastOffset = false

          this.searchedText = text

          let enforce = false

          if (!text) {
            enforce = true
          }

          if (text) {
            SessionStorage.setArrayItem('search', { key: window.location.href, text: text })
          }
          else {
            SessionStorage.clearArray('search', window.location.href)
          }

          this._gridLoadData('load', null, enforce)
        }
      }

      this.grid.bootstrapTable(options)

      this._setGridLastState()

      this._changeGridData()

      this._updateDataItem()
    }
    ,

    /**
     *
     * @private
     */
    _prepareEditorProps (rowData = {}) {
      return {
        id:                   rowData.hasOwnProperty('ID') ? rowData.ID : null,
        page:                 this.innerPageType,
        sourceType:           this.sourceType,
        businessRules:        this.businessRules,
        defaults:             rowData,
        formFields:           this.parsedFieldsData,
        idStructure:          this.idStructure,
        h1:                   this.h1,
        isReadOnly:           this.isReadOnly,
        parentPageDefinition: this.menuField
      }
    }
    ,

    /**
     *
     * @private
     */
    _changeGridData (row = null) {
      let promisses = []

      let data = this.data

      for (let i = 0; i < this.images.length; i++) {
        let imageSettings = this.images[i],
            columnName    = imageSettings.columnName,
            fileGUID      = imageSettings.fileGUID

        if (row) {
          data = [row]
        }

        for (let y = 0; y < data.length; y++) {
          let dataItem = data[y],
              id       = dataItem[columnName],
              guid     = dataItem[fileGUID],
              url      = 'Document/GetFile?idtDocument=' + id + '&fileGUID=' + guid +
                '&size=100&quality=30'

          let promise = http.get(url)
                            .then((response) => {
                              let src = 'data:image/jpeg;base64,' + response.data.fileContents

                              dataItem['_temp_' + columnName] = '<img src="' + src + '" />'

                              this.grid.bootstrapTable('updateByUniqueId', { id: dataItem.ID, row: dataItem })
                            })

          promisses.push(promise)

        }
      }

      return promisses
    }
    ,

    /**
     * @param pageTypeString
     * @private
     */
    _baseWatcherListener (pageTypeString) {
      let parsedData = this._parsePageTypeString(pageTypeString)

      this.innerPageType = parsedData[0]
      // this.storeGridData = this.$store.getters.getGridData(pageTypeString)
      this.idStructure   = parsedData[1] ? parsedData[1] : this.$route.params.idStructure

      let tempWhere          = this.where
      let tempWhereCondition = this.whereCondition

      let initDefinitions = this._initDefinitions()
      Promise
        .all([initDefinitions])
        .then(() => {

          this.where          = tempWhere === this.where ? tempWhere : this.where
          this.whereCondition = tempWhereCondition === this.whereCondition ? tempWhereCondition : this.whereCondition

          this._initGrid()

        })
        .catch((arg) => {
          for (let i = 0; i < arg.length; i++) {
            this.handleApiError(arg[i])
          }
        })
    }
    ,

    /**
     *
     * @private
     */
    _new () {
      if (this.isReadOnly) {
        return
      }

      this._saveGridState()

      let ruleParams = {
        ruleType: 'NEWREC',
        ruleName: this.businessRules.newrec,
        where:    this.whereCondition
      }

      // volani obchodniho pravidla NEWREC + zpracovani response
      this
        .resource
        .setDef(this.def)
        .callBusinessRule(ruleParams)
        .then((response) => {

          if (response.data.messages) {
            Swal.fire(response.data.messages, '')
          }

          PDELinkGenerator.defaults = response.data.values
          PDELinkGenerator.target   = PDELinkGenerator.targetNewName
          PDELinkGenerator.redir    = this.redir

          if (this.parent) {
            let parent                 = {
              id:           this.$route.params.id,
              page:         this.$route.params.page,
              idEStructure: this.$route.params.idStructure,
              label:        this.parent.data.SEARCHTEXT
            }
            PDELinkGenerator.parent    = JSON.stringify(parent)
            PDELinkGenerator.parentDef = this.parent.def
          }

          this.$router.push(PDELinkGenerator.getParams(this.def))
        })
        .catch((error) => {
          this.handleApiError(error)
        })
    }
    ,

    /**
     *
     * @param lastId
     */
    _saveGridState (lastId = null) {
      let params = {
        lastId:          lastId,
        lastPage:        this.innerPageType,
        idStructure:     this.$route.params.idStructure,
        lastData:        this.data,
        lastOffset:      this.offset,
        lastTopPosition: this.topPosition,
        searchedText:    this.searchedText,
        lastCount:       this.count,
        isLastOffset:    this.isLastOffset,
        lastResource:    this.resource
      }

      this.$store.commit('setGridData', params)
    }
    ,

    /**
     * Pokud jsou v aplikaci ulozena grid data nastav pozici na posledni stav + zvyrazni posledni radek
     *
     * @private
     */
    _setGridLastState () {
      if (this.storeGridData && this.storeGridData.lastPage === this.innerPageType) {
        let rowElement = $('tr[data-uniqueid="' + this.storeGridData.lastId + '"]')

        rowElement.closest('tbody').find('tr').removeClass('active')
        rowElement.closest('tbody').find('tr').removeClass('updated')
        rowElement.closest('tr').addClass('active')

        window.scrollTo(0, this.storeGridData.lastTopPosition)
      }
    }
    ,

    /**
     *
     * @private
     */
    _updateDataItem () {
      let storeRowData = this.$store.getters.getRowData

      if (!storeRowData) {
        storeRowData = this.row
      }

      if (!this.$store.getters.getGridEditTag) {
        return
      }

      if (!storeRowData) {
        return
      }

      this.$store.commit('setGridEditTag', false)
      this.$store.commit('setRowData', undefined)

      if (storeRowData.type === 'lastRow') {
        this._lastStateRow(storeRowData.data)

        return
      }

      if (storeRowData.type === 'update') {
        DataGridPreprocessor.preprocess(storeRowData.data, this.gridColumns)
        this._changeGridData(storeRowData.data) // @TODO: premistit do DataGridPreprocessoru
        this._updateRow(storeRowData.data)

        return
      }

      if (storeRowData.type === 'insert') {
        DataGridPreprocessor.preprocess(storeRowData.data, this.gridColumns)
        this._changeGridData(storeRowData.data)  // @TODO: premistit do DataGridPreprocessoru
        let finded = false
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].ID === storeRowData.data.ID) {
            finded = true
            break
          }
        }

        if (finded) {
          this._updateRow(storeRowData.data)
        }
        else {
          this._prependRow(storeRowData.data)
        }

        this._initData(null, this._prepareArgs(), true)

        return
      }

      if (storeRowData.type === 'delete') {
        this._deleteRow(storeRowData.data)
      }
    }
    ,

    /**
     *
     * @param args
     * @private
     */
    _lastStateRow (args) {
      this.grid.find('tr.updated').removeClass('updated')
      this.grid.find('[data-uniqueid="' + args.ID + '"]').addClass('active')
    }
    ,

    /**
     *
     * @param args
     * @private
     */
    _updateRow (args) {
      let data = this._findDataItem(args.ID)

      Object
        .keys(args)
        .map(key => {
          this.data[data.index][key] = args[key]
        })

      this.grid.bootstrapTable('updateByUniqueId', args)

      this.grid.find('tr.updated').removeClass('updated')
      this.grid.find('[data-uniqueid="' + args.ID + '"]').addClass('updated')
    }
    ,

    /**
     *
     * @param row
     * @private
     */
    _prependRow (row) {
      this.grid.bootstrapTable('prepend', row)

      this.grid.find('tr.updated').removeClass('updated')
      this.grid.find('[data-uniqueid="' + row.ID + '"]').addClass('updated')
    }
    ,

    /**
     *
     * @param row
     * @private
     */
    _deleteRow (row) {
      if (this.storeGridData) {
        this.count = this.storeGridData.lastCount - 1
      }

      this.grid.bootstrapTable('removeByUniqueId', row.ID)
    }
    ,

    /**
     *
     * @param itemId
     */
    _findDataItem (itemId) {
      itemId = parseInt(itemId)

      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].ID === itemId) {
          return { index: i, data: this.data[i] }
        }
      }
    }
    ,

    /**
     *
     * @private
     */
    _handleScroll () {
      if (this.scrollFiredPropLocal !== undefined && this.scrollFiredPropLocal !== null) {
        this.scrollFired          = this.scrollFiredPropLocal
        this.scrollFiredPropLocal = null
      }

      this.topPosition = $(document).scrollTop()

      let y      = window.pageYOffset,
          result = $(document).height() - $(window).height()

      if (result >= y + 80 && this.scrollFired) {
        this.scrollFired = false

        return
      }

      if (result <= y + 80 && !this.scrollFired) {
        this.scrollFired   = true
        this.storeGridData = null
        this.offset++

        this._gridLoadData('append')
      }
    }
    ,

    /**
     *
     * @return {{limit: null, offset: null}}
     * @private
     */
    _prepareArgs () {
      let args = {
        limit:  this.limit,
        offset: this.offset
      }

      if (this.orderBy) {
        args['orderBy'] = this.orderBy
      }

      if (this.whereCondition) {
        args['whereCondition'] = this.whereCondition

        return args
      }

      if (this.where) {
        args['whereCondition'] = this.where
      }

      if (this.searchedText) {
        args['searchText'] = this.searchedText
      }

      return args
    }
    ,

    /**
     *
     * @param pageTypeString
     * @returns {*}
     * @private
     */
    _parsePageTypeString (pageTypeString) {
      let pageType     = undefined,
          idtStructure = undefined

      if (pageTypeString.indexOf('%') > -1) {
        let splitPageType = pageTypeString.split('%')

        pageType     = splitPageType[0]
        idtStructure = splitPageType[1]
      }

      return [pageType, idtStructure]
    }
  }

}
</script>

<style scoped>

</style>
